exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/~/core-js/modules/_object-gops.js
// module id = ../../../../core-js/modules/_object-gops.js
// module chunks = 0